"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      marginTop: theme.spacing(-2),
      marginBottom: theme.spacing(8),
      lineHeight: theme.typography.pxToRem(12),
      overflowWrap: 'break-word',
      '.aem-AuthorLayer-Edit &': {
        marginTop: '0'
      },
      '& p, a': {
        display: 'block',
        marginBottom: '0px'
      },
      '& a': {
        marginTop: theme.spacing(1)
      }
    },
    authorLine: {
      display: 'block',
      lineHeight: theme.typography.pxToRem(15),
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'inherit'
    },
    articleWithAffiliations: {
      '& i': {
        marginBottom: '0px',
        marginTop: theme.spacing(1)
      }
    },
    referenceNum: {
      //Specificity hack to avoid use of important and override aem-page > sup margins
      '&$referenceNum': {
        fontSize: theme.typography.pxToRem(7)
      }
    }
  };
});
var AuthorEditConfig = {
  emptyLabel: 'Author',
  isEmpty: function isEmpty(props) {
    return !(props.authors && props.authors.length > 0);
  }
};
var getAuthorsList = function getAuthorsList(authors) {
  return authors.map(function (author, i) {
    var _author$authorName, _author$authorTitle, _author$affiliationCa;
    var authorName = (_author$authorName = author.authorName) !== null && _author$authorName !== void 0 ? _author$authorName : '';
    var authorTitle = (_author$authorTitle = author.authorTitle) !== null && _author$authorTitle !== void 0 ? _author$authorTitle : '';
    var affiliationCallout = (_author$affiliationCa = author.affiliationCallout) !== null && _author$affiliationCa !== void 0 ? _author$affiliationCa : '';
    var lastItem = authors.length - 1 === i;
    return __jsx(_react.Fragment, {
      key: i
    }, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: "".concat(authorName)
      }
    }), authorTitle && __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: "".concat(authorName ? ', ' : '').concat(authorTitle)
      }
    }), affiliationCallout && __jsx("sup", null, affiliationCallout), !lastItem && __jsx("span", null, ", "));
  });
};
var Author = function Author(_ref) {
  var _ref$authors = _ref.authors,
    authors = _ref$authors === void 0 ? [] : _ref$authors,
    articleVol = _ref.articleVol,
    email = _ref.email,
    affiliations = _ref.affiliations,
    anchorId = _ref.anchorId;
  var classes = useStyles();
  var totalAuthors = authors.length;
  if (!authors || totalAuthors === 0) return null;
  var isEmailAddress = function isEmailAddress(str) {
    return /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/.test(str);
  };
  var emails = (email === null || email === void 0 ? void 0 : email.split(',').map(function (str) {
    return str.trim();
  }).filter(isEmailAddress)) || [];
  return __jsx("div", {
    id: anchorId,
    className: classes.wrapper
  }, authors.length > 0 && __jsx(_core.Typography, {
    variant: "body2",
    className: classes.authorLine,
    display: "inline"
  }, __jsx("strong", null, getAuthorsList(authors))), affiliations !== null && affiliations !== void 0 && affiliations.length ? __jsx(_core.Typography, {
    variant: "body2",
    className: classes.authorLine
  }, affiliations.map(function (affiliation, i) {
    var hasMoreAffiliations = affiliations.length !== i + 1;
    return __jsx(_react.Fragment, {
      key: i
    }, affiliations.length > 1 ? __jsx("sup", {
      className: classes.referenceNum
    }, i + 1) : null, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: affiliation
      }
    }), hasMoreAffiliations ? ', ' : '');
  })) : null, articleVol && __jsx(_core.Typography, {
    variant: "body2",
    className: (0, _clsx.default)(classes.authorLine, (affiliations === null || affiliations === void 0 ? void 0 : affiliations.length) && classes.articleWithAffiliations)
  }, __jsx("i", {
    dangerouslySetInnerHTML: {
      __html: articleVol
    }
  })), emails.length > 0 && __jsx("div", {
    className: classes.authorLine
  }, emails.map(function (_email, _idx) {
    return __jsx("span", {
      key: _idx
    }, __jsx("a", {
      href: "mailto:".concat(_email),
      dangerouslySetInnerHTML: {
        __html: _email
      }
    }), _idx < emails.length - 1 && ", ");
  })));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/author')(Author, AuthorEditConfig);
exports.default = _default;